module.exports = __webpack_public_path__ + "static/media/app-development.c04aff1d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeDo/app-development.svg
// module id = 328
// module chunks = 0